import { render, staticRenderFns } from "./ShareToEditModal.vue?vue&type=template&id=1a2d43f1&scoped=true&"
import script from "./ShareToEditModal.vue?vue&type=script&lang=js&"
export * from "./ShareToEditModal.vue?vue&type=script&lang=js&"
import style0 from "./ShareToEditModal.vue?vue&type=style&index=0&id=1a2d43f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2d43f1",
  null
  
)

export default component.exports